/*
Calendar-based seasons matching Android Season.kt.

Mapping (Northern hemisphere meteorological seasons, December-February etc.):
  WINTER = 0  (Dec, Jan, Feb)
  SPRING = 1  (Mar, Apr, May)
  SUMMER = 2  (Jun, Jul, Aug)
  AUTUMN = 3  (Sep, Oct, Nov)

The integer ordinal is persisted in CaptureEntity.season — DO NOT reorder
or renumber, that field is part of the cross-platform backup contract
(BackupModels.kt) and is read directly from existing rows on disk.
*/

import type { SeasonOrdinal } from './types'

export const kSeasonLabels: Record<SeasonOrdinal, string> = {
	0: 'Hiver',
	1: 'Printemps',
	2: 'Été',
	3: 'Automne',
}

/*
Compute the season ordinal for a given timestamp using the user's local
time zone. Browser and Android use the device-local zone; Paris-based
users see the same boundaries on both platforms.
*/
export function seasonFromTimestamp(inTimestampMs: number): SeasonOrdinal
{
	const vMonth: number = new Date(inTimestampMs).getMonth()  // 0=Jan ... 11=Dec, local zone
	if (vMonth === 11 || vMonth <= 1) return 0
	if (vMonth <= 4) return 1
	if (vMonth <= 7) return 2
	return 3
}
